import api from "./api";

const VehicleTransferRequestService = {
  create: async (data) => {
    const response = await api.post("/vehicleTransferRequest/save", data);
    return response.data;
  },

  getAll: async () => {
    const response = await api.get("/vehicleTransferRequest/getAll");
    return response.data.data || response.data;
  },

  getActive: async () => {
    const response = await api.get("/vehicleTransferRequest/getActive");
    return response.data.data || response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/vehicleTransferRequest/getById/${id}`);
    return response.data.data || response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/vehicleTransferRequest/update/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/vehicleTransferRequest/${id}`);
    return response.data;
  },

  updateStatus: async (id, status) => {
    const response = await api.put(`/vehicleTransferRequest/updateStatus/${id}`, { status });
    return response.data;
  },

  approveLocalVehicleRequest: async (data) => {
    const response = await api.post("/vehicleTransferRequest/approveLocalVehicleRequest", data)
      ;
    return response.data;
  },
  approveCompanyVehicleRequest: async (data) => {
    const response = await api.post("/vehicleTransferRequest/approveCompanyVehicleRequest", data)
      ;
    return response.data;
  },

  rejectLocalVehicleRequest: async (data) => {
    const response = await api.post("/vehicleTransferRequest/rejectLocalVehicleRequest", data)
      ;
    return response.data;
  },
  escalateVehicleRequest: async (data) => {
    console.log("transfeer data:", data);
    const response = await api.post("/vehicleTransferRequest/escalatelVehicleRequest", data)
      ;
    return response.data;
  },
  transferVehicleRequest: async (data) => {
    const response = await api.post("/vehicleTransferRequest/transferVehicleRequest", data)
      ;
    return response.data;
  },
  releaseVehicle: async (data) => {
    const response = await api.post("/vehicleTransferRequest/releaseVehicle", data)
      ;
    return response.data;
  },
  receiveVehicle: async (data) => {
    const response = await api.post("/vehicleTransferRequest/receiveVehicle", data)
      ;
    return response.data;
  },
};
export default VehicleTransferRequestService;
